import React from 'react'
import * as S from './styled'
import ActionDialog from '../action-dialog'

// Envoltorio fino de ActionDialog que conserva la API de siempre: el contenido (con su propio
// título dentro) llega en textContent y Cancelar sólo aparece si se pasa cancelButton.
const ModalSimpleSmall = ({ open, handleClose, textContent, buttonTitle, cancelButton = null, handleButtonClick }) => {
  const handleModalClose = () => {
    handleClose();
  };

  return (
    <ActionDialog
      open={open}
      onClose={handleModalClose}
      onConfirm={handleButtonClick}
      confirmLabel={buttonTitle}
      cancelLabel={cancelButton}
      showCancel={!!cancelButton}
    >
      <S.Body>{textContent}</S.Body>
    </ActionDialog>
  )
}

export default ModalSimpleSmall
